import { gql } from "@apollo/client";

export const addFavourite = gql`
  mutation addFavourite($favouriteId: ID!, $favouriteType: FavouriteTypeEnum!) {
    addFavourite(favouriteId: $favouriteId, favouriteType: $favouriteType)
  }
`;
